import React, { useState } from 'react'
import Layout from '../../../../Layout/Layout'
import { useForm } from '@inertiajs/react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import ParticipantUidHeading from '../../../../Components/ParticipantUidHeading'

export default function RespiteServices() {
    const [showStartTimeInput, setShowStartTimeInput] = useState(false)
    const [showEndTimeInput, setShowEndTimeInput] = useState(false)
    const { data, setData, post, processing, errors } = useForm({
        manual_start_time: '',
        manual_end_time: '',
    })

    function handleSubmit(e) {
        e.preventDefault()
        post('/respite/create')
    }

    return (
        <Layout title="Respite Services">
            <form onSubmit={handleSubmit} className="respite-form">
                <div className="flex flex-col flex-wrap w-full bg-white shadow-md p-8 md:p-16 md:mb-0 mt-2">
                    <div className="flex flex-row flex-wrap items-center mb-4">
                        <h5 className="text-2xl text-gray-700 mr-2">
                            Processing Respite Services for:
                        </h5>
                        <ParticipantUidHeading />
                    </div>
                    <div className="flex flex-row flex-wrap items-center">
                        {errors.manual_end_time &&
                            errorMessage(errors.manual_end_time)}
                        {errors.manual_start_time &&
                            errorMessage(errors.manual_start_time)}
                        <div className="grid grid-cols-6 items-start w-full gap-8 mt-8">
                            <div className="flex flex-col gap-8 col-span-6 lg:col-span-3 shadow-sm p-4">
                                <button
                                    className={
                                        showStartTimeInput
                                            ? 'bg-customBlue  text-white px-4 py-2 w-auto hover:bg-customBlue/80 cursor-pointer'
                                            : 'bg-gray-200 px-4 py-2 w-auto hover:bg-gray-100 cursor-pointer'
                                    }
                                    type="button"
                                    id="show_manual_start_time"
                                    value={showStartTimeInput}
                                    onClick={(e) => {
                                        setData('manual_start_time', null)
                                        setShowStartTimeInput(
                                            !showStartTimeInput
                                        )
                                    }}
                                >
                                    Respite In
                                </button>
                                {showStartTimeInput ? (
                                    <div className="flex flex-col items-start gap-2 w-full">
                                        <label
                                            className="block text-gray-700 text-sm"
                                            htmlFor="manual_start_time"
                                        >
                                            Respite In Time
                                        </label>
                                        <div className="flex flex-row items-center gap-2 w-full">
                                            <DatePicker
                                                showTimeInput
                                                dateFormat="h:mm aa"
                                                showTimeSelectOnly
                                                timeIntervals={15}
                                                timeCaption="Time"
                                                selected={
                                                    data.manual_start_time
                                                        ? new Date(
                                                              data.manual_start_time
                                                          )
                                                        : null
                                                }
                                                onChange={(date) =>
                                                    setData(
                                                        'manual_start_time',
                                                        date
                                                            ? date.toISOString()
                                                            : null
                                                    )
                                                }
                                                className="w-full h-10 text-gray-700 border border-gray-400"
                                            />
                                            <button
                                                type="button"
                                                className=" cursor-pointer bg-gray-200 w-auto rounded p-2 whitespace-nowrap hover:bg-gray-100"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    setData(
                                                        'manual_start_time',
                                                        new Date().toISOString()
                                                    )
                                                }}
                                            >
                                                Now
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="flex flex-col gap-8 col-span-6 lg:col-span-3 shadow-sm p-4">
                                <button
                                    className={
                                        showEndTimeInput
                                            ? 'bg-customBlue  text-white px-4 py-2 w-auto hover:bg-customBlue/80 cursor-pointer'
                                            : 'bg-gray-200 px-4 py-2 w-auto hover:bg-gray-100 cursor-pointer'
                                    }
                                    type="button"
                                    id="show_manual_end_time"
                                    value={showEndTimeInput}
                                    onClick={(e) => {
                                        setData('manual_end_time', null)
                                        setShowEndTimeInput(!showEndTimeInput)
                                    }}
                                >
                                    Respite Out
                                </button>
                                {showEndTimeInput ? (
                                    <div className="flex flex-col items-start gap-2 w-full">
                                        <label
                                            className="block text-gray-700 text-sm mb-2 "
                                            htmlFor="manual_end_time"
                                        >
                                            Respite Out Time
                                        </label>
                                        <div className="flex flex-row items-center gap-2 w-full">
                                            <DatePicker
                                                showTimeInput
                                                dateFormat="h:mm aa"
                                                showTimeSelectOnly
                                                timeIntervals={15}
                                                timeCaption="Time"
                                                selected={
                                                    data.manual_end_time
                                                        ? new Date(
                                                              data.manual_end_time
                                                          )
                                                        : null
                                                }
                                                onChange={(date) =>
                                                    setData(
                                                        'manual_end_time',
                                                        date
                                                            ? date.toISOString()
                                                            : null
                                                    )
                                                }
                                                className="w-full h-10 text-gray-700 border border-gray-400"
                                            />
                                            <button
                                                type="button"
                                                className=" cursor-pointer bg-gray-200 w-auto rounded p-2 whitespace-nowrap hover:bg-gray-100"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    setData(
                                                        'manual_end_time',
                                                        new Date().toISOString()
                                                    )
                                                }}
                                            >
                                                Now
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-2 w-full p-4 shadow-sm mt-4">
                        <label
                            htmlFor="notes"
                            className="block text-gray-700 font-medium mb-2"
                        >
                            Notes
                        </label>
                        <textarea
                            className="w-full text-gray-700 border border-gray-200 min-h-24 p-2"
                            id="notes"
                            placeholder="Notes"
                            value={data.notes}
                            onChange={(e) => setData('notes', e.target.value)}
                        />
                    </div>
                </div>
                <div className="w-full flex flex-row flex-wrap bg-customBlue md:space-x-4 space-y-4 md:space-y-0 items-center py-7 px-8 md:px-16 mb-8">
                    <button
                        type="submit"
                        className="bg-white text-customBlue h-12 py-2 px-8 w-full justify-center md:w-auto font-bold flex flex-row items-center"
                        disabled={processing}
                    >
                        {processing && (
                            <div>
                                <svg
                                    className="animate-spin mr-2"
                                    width="18px"
                                    height="18px"
                                    viewBox="0 0 120 120"
                                >
                                    <g
                                        id="Artboard"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fill-rule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            transform="translate(9.000000, 9.000000)"
                                            stroke="#314EB9"
                                            strokeWidth="9"
                                        >
                                            <path
                                                d="M102,51 C102,22.8334778 79.1665222,0 51,0 C22.8334778,0 0,22.8334778 0,51 C0,79.1665222 22.8334778,102 51,102"
                                                id="Path"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        )}
                        Done
                    </button>
                    <div className="flex-col md:flex-row items-center w-auto md:w-auto bg-white rounded-full py-2">
                        <div className="flex flex-row items-center px-4">
                            <small className="pr-2">Step 1 of 1</small>
                            <div className="h-4 w-4 rounded-full bg-customBlue"></div>
                        </div>
                    </div>
                </div>
            </form>
        </Layout>
    )
}

const errorMessage = (error) => {
    return <p className="w-full my-1 text-red-500 text-xs italic">{error}</p>
}
